<template>
  <ModalCard>
    <template #header>
      <SkeletonView :height="100" />
    </template>
    <template #body>
      <SkeletonView :height="50" />
      <div class="columns py-5">
        <div class="column is-6">
          <div v-for="i in 7" :key="i" class="py-3">
            <SkeletonView :height="15" />
          </div>
        </div>
        <div class="column is-6">
          <div v-for="i in 5" :key="i" class="py-3">
            <SkeletonView :height="15" />
          </div>
        </div>
      </div>
      <SkeletonView :height="100" />
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SelfServeCheckoutSessionFlowCardSkeleton',
  components: { SkeletonView, ModalCard }
};
</script>
